/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UniswapV3PriceProviderXAI,
  UniswapV3PriceProviderXAIInterface,
  UniswapV3PriceProviderV3,
} from "../UniswapV3PriceProviderXAI";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Factory",
        name: "_factory",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "periodForAvgPrice",
            type: "uint32",
          },
          {
            internalType: "uint8",
            name: "blockTime",
            type: "uint8",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV3.PriceCalculationData",
        name: "_priceCalculationData",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "_xaiAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_xaiVirtualAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    name: "NewBlockTime",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "period",
        type: "uint32",
      },
    ],
    name: "NewPeriod",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "OwnershipPending",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IUniswapV3Pool[]",
        name: "pools",
        type: "address[]",
      },
    ],
    name: "PoolsForAsset",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_ACCEPTED_BLOCK_TIME",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "XAI_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "XAI_VIRTUAL_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "acceptOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "adjustOracleCardinality",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetOldestTimestamp",
    outputs: [
      {
        internalType: "uint32[]",
        name: "oldestTimestamps",
        type: "uint32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "assetSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_blockTime",
        type: "uint8",
      },
    ],
    name: "changeBlockTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_period",
        type: "uint32",
      },
    ],
    name: "changePeriodForAvgPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "observationsStatus",
    outputs: [
      {
        internalType: "bool",
        name: "bufferFull",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "enoughObservations",
        type: "bool",
      },
      {
        internalType: "uint16",
        name: "currentCardinality",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pendingOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV3.PricePath[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceCalculationData",
    outputs: [
      {
        internalType: "uint32",
        name: "periodForAvgPrice",
        type: "uint32",
      },
      {
        internalType: "uint8",
        name: "blockTime",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProviderPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
    ],
    name: "quotePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removePendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "_currentObservationIndex",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "_currentObservationCardinality",
        type: "uint16",
      },
    ],
    name: "resolveOldestObservationTimestamp",
    outputs: [
      {
        internalType: "uint32",
        name: "oldestTimestamp",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "setupAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newPendingOwner",
        type: "address",
      },
    ],
    name: "transferPendingOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswapV3Factory",
    outputs: [
      {
        internalType: "contract IUniswapV3Factory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IUniswapV3Pool[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "verifyPools",
    outputs: [
      {
        components: [
          {
            internalType: "contract IUniswapV3Pool",
            name: "pool",
            type: "address",
          },
          {
            internalType: "bool",
            name: "token0IsInterim",
            type: "bool",
          },
        ],
        internalType: "struct UniswapV3PriceProviderV3.PricePath[]",
        name: "path",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniswapV3PriceProviderXAIConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniswapV3PriceProviderXAIConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniswapV3PriceProviderXAI__factory extends ContractFactory {
  constructor(...args: UniswapV3PriceProviderXAIConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UniswapV3PriceProviderXAI";
  }

  deploy(
    _priceProvidersRepository: string,
    _factory: string,
    _priceCalculationData: UniswapV3PriceProviderV3.PriceCalculationDataStruct,
    _xaiAddress: string,
    _xaiVirtualAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniswapV3PriceProviderXAI> {
    return super.deploy(
      _priceProvidersRepository,
      _factory,
      _priceCalculationData,
      _xaiAddress,
      _xaiVirtualAddress,
      overrides || {}
    ) as Promise<UniswapV3PriceProviderXAI>;
  }
  getDeployTransaction(
    _priceProvidersRepository: string,
    _factory: string,
    _priceCalculationData: UniswapV3PriceProviderV3.PriceCalculationDataStruct,
    _xaiAddress: string,
    _xaiVirtualAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _priceProvidersRepository,
      _factory,
      _priceCalculationData,
      _xaiAddress,
      _xaiVirtualAddress,
      overrides || {}
    );
  }
  attach(address: string): UniswapV3PriceProviderXAI {
    return super.attach(address) as UniswapV3PriceProviderXAI;
  }
  connect(signer: Signer): UniswapV3PriceProviderXAI__factory {
    return super.connect(signer) as UniswapV3PriceProviderXAI__factory;
  }
  static readonly contractName: "UniswapV3PriceProviderXAI";
  public readonly contractName: "UniswapV3PriceProviderXAI";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapV3PriceProviderXAIInterface {
    return new utils.Interface(_abi) as UniswapV3PriceProviderXAIInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV3PriceProviderXAI {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UniswapV3PriceProviderXAI;
  }
}
